import script from "./exhibition.vue?vue&type=script&setup=true&lang=js"
export * from "./exhibition.vue?vue&type=script&setup=true&lang=js"

import "./exhibition.vue?vue&type=style&index=0&id=6deec058&lang=less&scoped=true"

import exportComponent from "/Users/timetravel/code/energy-storage-intelligence/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6deec058"]])

export default __exports__